<template>
  <div class="w-100">
     <grid-component
        isResizable
        :canEdit="checkClaim(CAN_EDIT_SALES_ORDER)"
        :canDelete="checkClaim(CAN_DELETE_SALES_ORDERS)"
        :gridId="gridId"
        :itemData="itemData"
        :navigationField="'partNumber'"
        :fields="fields"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
      />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';

import { GRID_ID } from '@/shared/constants';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    salesOrderId: {
      type:  [Number, String],
      default: 0,
    },
    showAllGridRows: {
      type: [Boolean],
      default: false,
    },
    showCheckbox: {
      type: [Boolean],
      default: false,
    },
    showEdit: {
      type: [Boolean],
      default: false,
    },
    showDelete: {
      type: [Boolean],
      default: false,
    },
    isFilteredList: {
      type: Boolean,
      default: false,
    },
    salesOrdersFiltered: {
      type: Array,
      default: () => []
    },
    componentKey:{
      type:  [Number, String],
      default: 0,
    }
  },
  data: () => ({
    prepareColumnsData,
    selectedRowItemId: 0,
    gridId: GRID_ID.SALES_ORDER_LINES,
    fields: gridFields,
    checkedRowItemIds: [],
  }),
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('salesOrderLines', ['salesOrderLinesById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    salesOrderLines() {
      return this.salesOrderLinesById(this.salesOrderId);
    },
    itemData() {
      let line = this.isFilteredList ? this.salesOrdersFiltered : this.salesOrderLines;

      return line.map((salesOrderLine) => ({ ...salesOrderLine, selected: salesOrderLine.id === this.selectedRowItemId }));
      //return this.salesOrderLines;
    },
    checkAllRows: {
      get() {
        //return false;
        return this.itemData && this.itemData.length ? this.checkedRowItemIds.length === this.itemData.length : false;
      },
      set(value) {
        const checked = [];

        if (value) {
          this.itemData.forEach((item) => {
            checked.push(item.id);
          });
        }

        this.checkedRowItemIds = checked;
      }
    },
  },
  methods: {
    ...mapActions('salesOrderLines', [
      'getBySalesOrderId',
      'deleteSalesOrderLine'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    // ...mapMutations('salesOrderLines', ['clearSalesOrderLines', 'setItem']),
    ...mapMutations('salesOrderLines', ['setItem']),
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: this.gridId,
        settings: {
          columns: newColumns,
        },
      });
    }, 500),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: this.gridId,
        settings: {
          columns: newColumns,
        },
      });
    },
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
    onEdit(data) {
      this.$emit('onShowEdit', data);
    },
    async onDelete(salesOrderLine) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete sales order line with id :${salesOrderLine.id}?`});
      if (deleteConfirmed) {
        const result = await this.deleteSalesOrderLine(salesOrderLine.id);
        this.getBySalesOrderId(this.salesOrderId);
      }
    },
    emitSalesOrderLine(newVal){
      const selectedRow = this.salesOrderLines.find(salesOrderLine => salesOrderLine.id === newVal);
      this.$emit('selectedSalesOrderLine', selectedRow);
    }
  },
  watch: {
    salesOrderId() {
      if(this.salesOrderId) {
        this.getBySalesOrderId(this.salesOrderId);
      } else {
        // this.clearSalesOrderLines();
        this.setItem({ resource: 'salesOrderLines', payload: [] });
      }
    },
    salesOrderLines() {
      if(this.salesOrderLines.length > 0 && this.selectedRowItemId === 0){
        this.selectedRowItemId = this.salesOrderLines[0].id;
      }
    },
    selectedRowItemId(newVal) {
      /*const selectedRow = this.salesOrderLines.find(salesOrderLine => salesOrderLine.id === newVal);
      this.$emit('selectedSalesOrderLine', selectedRow);*/
      this.emitSalesOrderLine(newVal);
    },
    checkedRowItemIds() {
      this.$emit('updateCheckedRowItemIds', this.checkedRowItemIds);
    },
    componentKey(){
      this.emitSalesOrderLine(this.selectedRowItemId);
    }
  },
  mounted() {
    if(this.salesOrderId){
      this.getBySalesOrderId(this.salesOrderId);
    }
  },
};
</script>

<style scoped>
.sales-order-lines-grid {
  height: 185px !important;
}
</style>
